import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
	mode: "history",
	routes: [{
		path: "/",
		name: "Index",
		redirect: "/login",
	}, {
		//公共组件-topBar
		path: "",
		name: "TopBar",
		component: () => import("../components/common/TopBar.vue"),
	}, {
		//公共组件-memberMenu
		path: "",
		name: "MemberMenu",
		component: () => import("../components/common/MemberMenu.vue"),
	}, {
		//公共组件-NoticeList
		path: "",
		name: "NoticeList",
		component: () => import("../components/common/NoticeList.vue"),
	}, {
		//公共组件-scheduleBar
		path: "",
		name: "ScheduleBar",
		component: () => import("../components/tools/ScheduleBar.vue"),
	}, {
		//公共组件-searchBar
		path: "",
		name: "SearchBar",
		component: () => import("../components/tools/SearchBar.vue"),
	}, {
		//公共组件-TipsModal
		path: "",
		name: "TipsModal",
		component: () => import("../components/tools/TipsModal.vue"),
	}, {
		//公共组件-ScheduleCalendar
		path: "",
		name: "ScheduleCalendar",
		component: () => import("../components/schedule/ScheduleCalendar.vue"),
	}, {
		//公共组件-EditSchedule
		path: "",
		name: "EditSchedule",
		component: () => import("../components/schedule/EditSchedule.vue"),
	}, {
		//公共组件-ScheduleList
		path: "",
		name: "ScheduleList",
		component: () => import("../components/schedule/ScheduleList.vue"),
	}, {
		//公共组件-editUser
		path: "",
		name: "EditUser",
		component: () => import("../components/user/EditUser.vue"),
	}, {
		//首页-日历模式日程
		path: "/home",
		name: "Home",
		component: () => import("../pages/home/Home.vue"),
	}, {
		//列表模式-日程
		path: "/listModeSchedule",
		name: "ListModeSchedule",
		component: () => import("../pages/listModeSchedule/ListModeSchedule.vue"),
	}, {
		//用户管理
		path: "/userManage",
		name: "UserManage",
		component: () => import("../pages/userManage/UserManage.vue"),
	}, {
		//登录
		path: "/login",
		name: "Login",
		component: () => import("../pages/login/Login.vue"),
	}],
});

export default router;